module.exports = __webpack_public_path__ + "static/media/peopleGroup6.9f643967.jpg";